import Atendimento from "../entities/Atendimento";
import ItemHistorico from "../entities/ItemHistorico";

export default class ServicoTesteArvore {
    constructor({ mapaProcessadores }) {
        this.atendimento = null;
        this.mapaProcessadores = mapaProcessadores;
    }

    iniciarTeste(arvore) {
        this.atendimento = new Atendimento(arvore);
    }

    telaAtual() {
        if (!this.atendimento) {
            return null;
        }
        if (this.atendimento.telaAtual === "#final") {
            return {
                tipo: "final",
            };
        }
        return this.atendimento.arvore.telas[this.atendimento.telaAtual];
    }

    getDados() {
        return this.atendimento?.dados;
    }

    atribuicoes() {
        return this.atendimento?.atribuicoes;
    }

    criarItemHistorico({ dados, atribuicoes }) {
        const copiaDados = Object.assign({}, dados);
        const copiaAtribuicoes = Object.assign({}, atribuicoes);
        return new ItemHistorico({
            nomeTela: this.atendimento.telaAtual,
            dados: copiaDados,
            atribuicoes: copiaAtribuicoes,
        });
    }

    atualizarTelaAtual({ proximaTela, item, atribuicoes }) {
        this.atendimento.historico.inserir(item);
        this.atendimento.dados = {};
        this.atendimento.telaAtual = proximaTela;
        this.atendimento.atribuicoes = Object.assign({}, atribuicoes);
    }

    async processarTela(dados) {
        const processador = this.mapaProcessadores(this.telaAtual().tipo);
        const atribuicoes = this.atendimento.atribuicoes;
        const item = this.criarItemHistorico({ dados, atribuicoes });
        const tela = this.telaAtual();
        const proximaTela = await processador.processar({
            dados,
            tela,
            atribuicoes,
        });
        this.atualizarTelaAtual({
            proximaTela,
            item,
            atribuicoes,
        });
    }

    voltar() {
        if (!this.atendimento.historico.podeVoltar()) {
            this.atendimento = null;
            return;
        }
        const item = this.atendimento.historico.voltar();
        this.atendimento.dados = item.dados;
        this.atendimento.telaAtual = item.nomeTela;
        this.atendimento.atribuicoes = item.atribuicoes;
    }

    cancelar() {
        this.atendimento = null;
    }

    criarChamado() {
        return new Promise((resolve) => {
            setTimeout(() => {
                const ticket = {
                    ticketId: 1,
                    ticketNumber: "1984170100003423423434",
                };
                resolve(ticket);
            }, 1000);
        });
    }

    encerrarAtendimento() {
        this.atendimento = null;
    }
}
